export const AWS_LAMBDA_TAGS_ANNOTATION = 'aws.amazon.com/amazon-lambda-tags'

export interface AwsLambda {
  accountId: string
  architecture: string
  arn: string
  functionName: string
  runtime: string
  state: string
  lastUpdateStatus: string
  memorySize: number
  concurrentExecutions: number
  environment?: string[] // Don't return values for now, for security reasons
  region: string
  tags?: Record<string, string>
  layers: string[]
}
